/**
 * Enum Module
 * 통합 Enum export
 *
 * 구조:
 * - backend.js  : 백엔드 동기화 enum + Style (BE_*, *_STYLE)
 * - frontend.js : 서버 대응 enum 이 없는 클라 전용 (FE_*)
 */

import BackendEnum from './backend';
import FrontendEnum from './frontend';

/**
 * 통합 Enum 클래스
 * 기존 Enum 클래스와 동일한 인터페이스 유지 (하위호환)
 */
class Enum {
    // Backend Enums - Common
    static get BE_OPERATOR() {
        return BackendEnum.BE_OPERATOR;
    }

    static get BE_HTTP_METHOD() {
        return BackendEnum.BE_HTTP_METHOD;
    }

    static get BE_METHOD() {
        return BackendEnum.BE_METHOD;
    }

    static get BE_PRIORITY() {
        return BackendEnum.BE_PRIORITY;
    }

    static get BE_TIME_UNIT() {
        return BackendEnum.BE_TIME_UNIT;
    }

    static get BE_HISTORY_SOURCE() {
        return BackendEnum.BE_HISTORY_SOURCE;
    }

    static get BE_HISTORY_ACTION() {
        return BackendEnum.BE_HISTORY_ACTION;
    }

    // Backend Enums - User
    static get BE_USER_ROLE() {
        return BackendEnum.BE_USER_ROLE;
    }

    static get BE_USER_ROLE_STYLE() {
        return BackendEnum.BE_USER_ROLE_STYLE;
    }

    static get BE_USER_STATE() {
        return BackendEnum.BE_USER_STATE;
    }

    static get BE_USER_STATE_STYLE() {
        return BackendEnum.BE_USER_STATE_STYLE;
    }

    static get BE_USER_AUTHORITY() {
        return BackendEnum.BE_USER_AUTHORITY;
    }

    // Backend Enums - Member
    static get BE_MEMBER_ROLE() {
        return BackendEnum.BE_MEMBER_ROLE;
    }

    static get BE_MEMBER_ROLE_STYLE() {
        return BackendEnum.BE_MEMBER_ROLE_STYLE;
    }

    static get BE_MEMBER_STATE() {
        return BackendEnum.BE_MEMBER_STATE;
    }

    static get BE_MEMBER_STATE_STYLE() {
        return BackendEnum.BE_MEMBER_STATE_STYLE;
    }

    static get BE_MEMBER_AUTHORITY() {
        return BackendEnum.BE_MEMBER_AUTHORITY;
    }

    static get BE_DEPARTMENT_MEMBER_ROLE() {
        return BackendEnum.BE_DEPARTMENT_MEMBER_ROLE;
    }

    static get BE_DEPARTMENT_MEMBER_ROLE_STYLE() {
        return BackendEnum.BE_DEPARTMENT_MEMBER_ROLE_STYLE;
    }

    static get BE_DOCUMENT_PARTICIPANT_ACTOR_TYPE() {
        return BackendEnum.BE_DOCUMENT_PARTICIPANT_ACTOR_TYPE;
    }

    static get BE_DOCUMENT_PARTICIPANT_ACTOR_TYPE_STYLE() {
        return BackendEnum.BE_DOCUMENT_PARTICIPANT_ACTOR_TYPE_STYLE;
    }

    // Backend Enums - Label
    static get BE_LABEL_TYPE() {
        return BackendEnum.BE_LABEL_TYPE;
    }

    static get BE_LABEL_REFERENCE_TYPE() {
        return BackendEnum.BE_LABEL_REFERENCE_TYPE;
    }

    // Backend Enums - Seal
    static get BE_SEAL_TYPE() {
        return BackendEnum.BE_SEAL_TYPE;
    }

    static get BE_SEAL_TYPE_STYLE() {
        return BackendEnum.BE_SEAL_TYPE_STYLE;
    }

    static get BE_SEAL_STATE() {
        return BackendEnum.BE_SEAL_STATE;
    }

    static get BE_SEAL_STATE_STYLE() {
        return BackendEnum.BE_SEAL_STATE_STYLE;
    }

    static get BE_SEAL_STATUS() {
        return BackendEnum.BE_SEAL_STATUS;
    }

    // Backend Enums - Document Template
    static get BE_DOCUMENT_TEMPLATE_STATE() {
        return BackendEnum.BE_DOCUMENT_TEMPLATE_STATE;
    }

    static get BE_DOCUMENT_TEMPLATE_STATE_STYLE() {
        return BackendEnum.BE_DOCUMENT_TEMPLATE_STATE_STYLE;
    }

    static get BE_DOCUMENT_TEMPLATE_STATUS() {
        return BackendEnum.BE_DOCUMENT_TEMPLATE_STATUS;
    }

    static get BE_DOCUMENT_TEMPLATE_STATUS_STYLE() {
        return BackendEnum.BE_DOCUMENT_TEMPLATE_STATUS_STYLE;
    }

    static get BE_DOCUMENT_TEMPLATE_FAVORITE_REFERENCE_TYPE() {
        return BackendEnum.BE_DOCUMENT_TEMPLATE_FAVORITE_REFERENCE_TYPE;
    }

    // Backend Enums - Document Draft
    static get BE_DOCUMENT_DRAFT_STATUS() {
        return BackendEnum.BE_DOCUMENT_DRAFT_STATUS;
    }

    static get BE_DOCUMENT_DRAFT_STATUS_STYLE() {
        return BackendEnum.BE_DOCUMENT_DRAFT_STATUS_STYLE;
    }

    static get BE_BASE_DOCUMENT_TYPE() {
        return BackendEnum.BE_BASE_DOCUMENT_TYPE;
    }

    // Backend Enums - Document
    static get BE_DOCUMENT_STATUS() {
        return BackendEnum.BE_DOCUMENT_STATUS;
    }

    static get BE_DOCUMENT_STATUS_STYLE() {
        return BackendEnum.BE_DOCUMENT_STATUS_STYLE;
    }

    static get BE_DOCUMENT_CONVERT_STATUS() {
        return BackendEnum.BE_DOCUMENT_CONVERT_STATUS;
    }

    static get BE_DOCUMENT_CONVERT_STATUS_STYLE() {
        return BackendEnum.BE_DOCUMENT_CONVERT_STATUS_STYLE;
    }

    static get BE_DOCUMENT_SEAL_HISTORY_ACTION() {
        return BackendEnum.BE_DOCUMENT_SEAL_HISTORY_ACTION;
    }

    static get BE_DOCUMENT_LABEL_REFERENCE_TYPE() {
        return BackendEnum.BE_DOCUMENT_LABEL_REFERENCE_TYPE;
    }

    static get BE_DOCUMENT_DATA_TYPE() {
        return BackendEnum.BE_DOCUMENT_DATA_TYPE;
    }

    static get BE_DOCUMENT_DOWNLOAD_DOMAIN() {
        return BackendEnum.BE_DOCUMENT_DOWNLOAD_DOMAIN;
    }

    static get BE_DOCUMENT_PROCESS_HISTORY_TYPE() {
        return BackendEnum.BE_DOCUMENT_PROCESS_HISTORY_TYPE;
    }

    static get BE_DOCUMENT_PROCESS_HISTORY_REFERENCE_TYPE() {
        return BackendEnum.BE_DOCUMENT_PROCESS_HISTORY_REFERENCE_TYPE;
    }

    static get BE_DOCUMENT_RESOURCE_CONVERT_STATUS() {
        return BackendEnum.BE_DOCUMENT_RESOURCE_CONVERT_STATUS;
    }

    static get BE_DOCUMENT_RESOURCE_CONVERT_STATUS_STYLE() {
        return BackendEnum.BE_DOCUMENT_RESOURCE_CONVERT_STATUS_STYLE;
    }

    // Backend Enums - Document Requester
    static get BE_DOCUMENT_REQUESTER_STATUS() {
        return BackendEnum.BE_DOCUMENT_REQUESTER_STATUS;
    }

    // Backend Enums - Document Approver
    static get BE_DOCUMENT_APPROVER_STATUS() {
        return BackendEnum.BE_DOCUMENT_APPROVER_STATUS;
    }

    static get BE_DOCUMENT_APPROVER_STATUS_STYLE() {
        return BackendEnum.BE_DOCUMENT_APPROVER_STATUS_STYLE;
    }

    // Backend Enums - Document Seal Approver
    static get BE_DOCUMENT_SEAL_APPROVER_STATUS() {
        return BackendEnum.BE_DOCUMENT_SEAL_APPROVER_STATUS;
    }

    static get BE_DOCUMENT_SEAL_APPROVER_STATUS_STYLE() {
        return BackendEnum.BE_DOCUMENT_SEAL_APPROVER_STATUS_STYLE;
    }

    // Backend Enums - Document Seal Manager
    static get BE_DOCUMENT_SEAL_MANAGER_STATUS() {
        return BackendEnum.BE_DOCUMENT_SEAL_MANAGER_STATUS;
    }

    static get BE_DOCUMENT_SEAL_MANAGER_STATUS_STYLE() {
        return BackendEnum.BE_DOCUMENT_SEAL_MANAGER_STATUS_STYLE;
    }

    // Backend Enums - Document Revoker
    static get BE_DOCUMENT_REVOKER_TYPE() {
        return BackendEnum.BE_DOCUMENT_REVOKER_TYPE;
    }

    static get BE_DOCUMENT_REVOKER_REFERENCE_TYPE() {
        return BackendEnum.BE_DOCUMENT_REVOKER_REFERENCE_TYPE;
    }

    // Backend Enums - Notification
    static get BE_NOTIFICATION_TYPE() {
        return BackendEnum.BE_NOTIFICATION_TYPE;
    }

    static get BE_NOTIFICATION_CONTEXT() {
        return BackendEnum.BE_NOTIFICATION_CONTEXT;
    }

    static get BE_NOTIFICATION_STATUS() {
        return BackendEnum.BE_NOTIFICATION_STATUS;
    }

    static get BE_NOTIFICATION_STATUS_STYLE() {
        return BackendEnum.BE_NOTIFICATION_STATUS_STYLE;
    }

    static get BE_NOTIFICATION_REFERENCE_TYPE() {
        return BackendEnum.BE_NOTIFICATION_REFERENCE_TYPE;
    }

    static get BE_NOTIFICATION_RECEIVER_REFERENCE_TYPE() {
        return BackendEnum.BE_NOTIFICATION_RECEIVER_REFERENCE_TYPE;
    }

    // Backend Enums - Resource
    static get BE_RESOURCE_TYPE() {
        return BackendEnum.BE_RESOURCE_TYPE;
    }

    static get BE_RESOURCE_REFERENCE_TYPE() {
        return BackendEnum.BE_RESOURCE_REFERENCE_TYPE;
    }

    // Backend Enums - Attachment
    static get BE_ATTACHMENT_REFERENCE_TYPE() {
        return BackendEnum.BE_ATTACHMENT_REFERENCE_TYPE;
    }

    // Backend Enums - Role
    static get BE_ROLE_TYPE() {
        return BackendEnum.BE_ROLE_TYPE;
    }

    // Backend Enums - Hook
    static get BE_HOOK_EVENT_DOMAIN() {
        return BackendEnum.BE_HOOK_EVENT_DOMAIN;
    }

    static get BE_HOOK_EVENT_TYPE() {
        return BackendEnum.BE_HOOK_EVENT_TYPE;
    }

    static get BE_HOOK_EVENT_REFERENCE_TYPE() {
        return BackendEnum.BE_HOOK_EVENT_REFERENCE_TYPE;
    }

    static get BE_HOOK_REFERENCE_TYPE() {
        return BackendEnum.BE_HOOK_REFERENCE_TYPE;
    }

    static get BE_HOOK_STATUS() {
        return BackendEnum.BE_HOOK_STATUS;
    }

    static get BE_HOOK_STATUS_STYLE() {
        return BackendEnum.BE_HOOK_STATUS_STYLE;
    }

    static get BE_WEBHOOK_HISTORY_RESULT() {
        return BackendEnum.BE_WEBHOOK_HISTORY_RESULT;
    }

    static get BE_WEBHOOK_HISTORY_RESULT_STYLE() {
        return BackendEnum.BE_WEBHOOK_HISTORY_RESULT_STYLE;
    }

    // Backend Enums - Workspace
    static get BE_WORKSPACE_CONFIG_KEY() {
        return BackendEnum.BE_WORKSPACE_CONFIG_KEY;
    }

    // Backend Enums - Owner
    // Backend Enums - Published Department
    // Backend Enums - Seal Ledger
    static get BE_SEAL_LEDGER_STATUS() {
        return BackendEnum.BE_SEAL_LEDGER_STATUS;
    }

    static get BE_SEAL_LEDGER_STATUS_STYLE() {
        return BackendEnum.BE_SEAL_LEDGER_STATUS_STYLE;
    }

    static get BE_SEAL_LEDGER_CONVERT_STATUS() {
        return BackendEnum.BE_SEAL_LEDGER_CONVERT_STATUS;
    }

    static get BE_SEAL_LEDGER_CONVERT_STATUS_STYLE() {
        return BackendEnum.BE_SEAL_LEDGER_CONVERT_STATUS_STYLE;
    }

    static get BE_ACTED_ROLE() {
        return BackendEnum.BE_ACTED_ROLE;
    }

    static get BE_CALLBACK_REFERENCE_TYPE() {
        return BackendEnum.BE_CALLBACK_REFERENCE_TYPE;
    }
    static get BE_DOCUMENT_EXTRACT_DATA_DOMAIN() {
        return BackendEnum.BE_DOCUMENT_EXTRACT_DATA_DOMAIN;
    }
    static get BE_HISTORY_REFERENCE_TYPE() {
        return BackendEnum.BE_HISTORY_REFERENCE_TYPE;
    }

    // Frontend Enums
    static get FE_DOCUMENT_RECEIVED_TYPE() {
        return FrontendEnum.FE_DOCUMENT_RECEIVED_TYPE;
    }

    static get FE_DATE_COMMUNICATION() {
        return FrontendEnum.FE_DATE_COMMUNICATION;
    }
}

export default Enum;

// Named exports for direct import
export {BackendEnum};
